import Modal from './Modal'

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Подтвердить',
  danger = false,
  isPending = false,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <p className="text-base font-bold mb-2">{title}</p>
      {message && <p className="text-sm text-muted mb-6">{message}</p>}
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onConfirm}
          disabled={isPending}
          className={`flex-1 py-2.5 rounded-xl text-sm font-bold border transition-all disabled:opacity-60
            ${danger
              ? 'bg-red-600/15 text-red-400 border-red-600/30 hover:bg-red-600/25'
              : 'bg-accent text-on-accent border-transparent hover:opacity-90'
            }`}
        >
          {isPending ? 'Удаление…' : confirmLabel}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="flex-1 py-2.5 rounded-xl text-sm font-semibold bg-surface2 text-fg hover:bg-surface3 transition-colors"
        >
          Отмена
        </button>
      </div>
    </Modal>
  )
}
